class AccountSettings.ReplyBlacklistsListView extends Backbone.View
  template: JST["backbone/templates/account_settings/reply_blacklists/list"]


  events:
    'click .edit-reply_blacklist': 'onClickEdit'
    'click .delete-reply_blacklist': 'onClickDelete'

  initialize: (@options = {}) ->
    @reply_blacklists = @options.reply_blacklists
    @all_groups = @options.groups

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    reply_blacklistId = $(evt.currentTarget).data('id')
    reply_blacklist_to_edit = @reply_blacklists.get(reply_blacklistId)
    @trigger('edit', reply_blacklist_to_edit)

  onClickDelete: (evt) ->
    swal({
        title: I18n.t('monitoring.reply_blacklist.delete.msg')
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('monitoring.reply_blacklist.y')
        cancelButtonText: I18n.t('monitoring.reply_blacklist.n')
        closeOnConfirm: true
      }, =>
        reply_blacklistId = $(evt.currentTarget).data('id')
        reply_blacklistToDelete = @reply_blacklists.get(reply_blacklistId)
        reply_blacklistToDelete.destroy(
          success: (response) =>
            @reply_blacklists.remove(reply_blacklistToDelete)
            console.log("Deleted reply_blacklist #{reply_blacklistToDelete.get('name')}")
            @render()
          error: (response) =>
            console.log("Error deleting reply_blacklist #{reply_blacklistToDelete.get('name')}")
        )
    )
